import { debounce } from "lodash-es";
import { ref } from "vue-demi";
const bodyWidth = ref(0);
const bodyHeight = ref(0);
const resizeObserverFun = debounce((entries) => {
  const body = entries[0];
  if (!body || !body.borderBoxSize)
    return;
  const borderBoxSize = body.borderBoxSize[0];
  if (!borderBoxSize)
    return;
  bodyWidth.value = borderBoxSize.inlineSize;
  bodyHeight.value = borderBoxSize.blockSize;
}, 600);
const resizeObserver = new ResizeObserver(resizeObserverFun);
resizeObserver.observe(document.body);
export { bodyHeight, bodyWidth };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/utils/bodySize.js